export function setListening(on: boolean): void {
  document.body.classList.toggle('listening', on);
}

export function mountSea(root: HTMLElement): void {
  root.insertAdjacentHTML(
    'afterbegin',
    `<div class="sea"></div>
     <div class="wave-grain"></div>
     <div class="wave-fine"></div>
     <div class="grain"></div>
     <div class="glints">
       ${[
         { l: 12, t: 18, d: 0 },
         { l: 78, t: 14, d: 1.2 },
         { l: 32, t: 40, d: 2.4 },
         { l: 88, t: 58, d: 0.8 },
         { l: 18, t: 68, d: 3 },
         { l: 62, t: 78, d: 1.6 },
         { l: 48, t: 10, d: 2 },
       ]
         .map(
           (g) =>
             `<div class="glint" style="left:${g.l}%;top:${g.t}%;animation-delay:${g.d}s"></div>`,
         )
         .join('')}
     </div>
     <div class="moonlight" id="moonlight"></div>`,
  );

  mountCursor();
}

function mountCursor(): void {
  const moonlight = document.getElementById('moonlight');
  if (!moonlight) return;
  let mx = innerWidth / 2,
    my = innerHeight / 2,
    cx = mx,
    cy = my,
    lastTrail = 0;
  const TRAIL_MAX = 18;
  const trail: HTMLDivElement[] = [];
  let trailGen = 0;

  addEventListener('mousemove', (e) => {
    mx = e.clientX;
    my = e.clientY;
    const now = performance.now();
    if (now - lastTrail > 38) {
      spawnTrail(e.clientX, e.clientY);
      lastTrail = now;
    }
  });

  const tick = (): void => {
    cx += (mx - cx) * 0.22;
    cy += (my - cy) * 0.22;
    moonlight.style.transform = `translate(${cx}px, ${cy}px) translate(-50%, -50%)`;
    requestAnimationFrame(tick);
  };
  tick();

  function spawnTrail(x: number, y: number): void {
    let d: HTMLDivElement;
    if (trail.length >= TRAIL_MAX) {
      d = trail.shift() as HTMLDivElement;
      d.style.animation = 'none';
      void d.offsetHeight;
      d.style.animation = '';
    } else {
      d = document.createElement('div');
      d.className = 'trail-dot';
      document.body.appendChild(d);
    }
    d.dataset.gen = String(++trailGen);
    const myGen = d.dataset.gen;
    const size = 60 + Math.random() * 30;
    d.style.width = `${size}px`;
    d.style.height = `${size}px`;
    d.style.left = `${x}px`;
    d.style.top = `${y}px`;
    trail.push(d);
    setTimeout(() => {
      if (d.dataset.gen !== myGen) return; // node was recycled — leave it alone
      const i = trail.indexOf(d);
      if (i !== -1) trail.splice(i, 1);
      d.remove();
    }, 900);
  }
}
